import type { RouteObject } from 'react-router';

import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { CONFIG } from 'src/global-config';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

import ChannelStepView from '../step';
import ChannelEdit from '../channelEdit';
import { usePathname } from '../../../routes/hooks';

// ----------------------------------------------------------------------
const ChannelListPage = lazy(() => import('src/pages/channel/list'));

// ----------------------------------------------------------------------

function SuspenseOutlet() {
  const pathname = usePathname();
  return (
    <Suspense key={pathname} fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  );
}

const dashboardLayout = () => (
  <DashboardLayout>
    <SuspenseOutlet />
  </DashboardLayout>
);

export const channelRoutes: RouteObject[] = [
  {
    path: 'channel',
    element: CONFIG.auth.skip ? dashboardLayout() : <AuthGuard>{dashboardLayout()}</AuthGuard>,
    children: [
      { index: true, element: <ChannelListPage /> },
      { path: 'step', element: <ChannelStepView /> },
      { path: ':id/edit', element:<ChannelEdit/> },
    ],
  },
];
